import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Landing from "./components/landing";
import Aviso from "./components/aviso";
import Codigo from "./components/codigo";
import Galeria from "./components/galeria";



const App = () => {
    return (
      <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Landing}/>
        <Route exact path="/aviso" component={Aviso}/>
        <Route exact path="/codigo" component={Codigo}/>
        <Route exact path="/galeria" component={Galeria}/>
      </Switch>
      </BrowserRouter>
    );
  }

export default App;



// WEBPACK FOOTER //
// ./src/App.js